import { Controller } from "@hotwired/stimulus"

// La page « Migrations » du catalogue (Insurance::MigrationsController, docs/produit-modulaire/migrations.md), posé
// sur son conteneur :
// - filter : un filtre de la grille change → le formulaire part (GET ; Turbo remplace la page, la sélection du panneau
//   est gardée en champs cachés) ;
// - select : un clic sur un lien qui vise le panneau (une ligne ou une case de la grille, dont la frame a le panneau
//   pour cible ; un gisement, un produit du panneau, qui le nomment en data-turbo-frame) → la ligne, et la case pour un
//   produit, sont marquées tout de suite (is-selected), la ligne ramenée dans la vue ; la frame du panneau charge
//   l'impact et avance l'adresse. Sans JavaScript, ces liens ouvrent la page complète, panneau rempli et sélection
//   marquée par le serveur ;
// - loaded : le panneau a chargé (turbo:frame-load) → sur grand écran, son cadre collant défile seul : il repart du haut
//   (l'autoscroll de la frame ne le fait pas quand l'impact est plus haut que le cadre).
// Cible : panel, le cadre du panneau.
const FRAME = "insurance_migrations_impact"

export default class extends Controller {
  static targets = ["panel"]

  loaded(event) {
    if (event.target.id !== FRAME || !this.hasPanelTarget) return

    this.panelTarget.scrollTop = 0
  }

  filter(event) {
    const form = event.target.form
    if (form) form.requestSubmit()
  }

  select(event) {
    const link = event.target.closest(`a[data-turbo-frame="${FRAME}"], turbo-frame[target="${FRAME}"] a[href]`)
    if (!link || !this.element.contains(link)) return

    const url = new URL(link.href, window.location.href)
    const key = url.searchParams.get("champ")
    if (key) this.mark(key, url.searchParams.get("produit"))
  }

  mark(key, code) {
    for (const element of this.element.querySelectorAll(".insurance-migrations-grid .is-selected")) {
      element.classList.remove("is-selected")
    }
    for (const element of this.element.querySelectorAll(".insurance-migrations-grid [aria-current]")) {
      element.removeAttribute("aria-current")
    }

    const row = this.element.querySelector(`#champ-${key.replace(/[._]/g, "-")}`)
    if (!row) return

    row.classList.add("is-selected")
    if (code) {
      for (const cell of row.querySelectorAll("a.insurance-migrations-cell")) {
        if (new URL(cell.href, window.location.href).searchParams.get("produit") === code) cell.classList.add("is-selected")
      }
    } else {
      row.querySelector(".insurance-migrations-grid__field-link")?.setAttribute("aria-current", "true")
    }
    // L'en-tête de ligne, collant à gauche : toujours visible horizontalement, seul le défilement vertical bouge.
    row.querySelector("th")?.scrollIntoView({ block: "nearest", inline: "nearest" })
  }
}
